import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  PageContent,
  Container,
  Pagination,
  FiltersControls,
  BoxList,
  Spinner,
  Alerts,
} from 'components';
import {
  loadUserCoursesCreator,
  setUserCoursesPageCreator,
  setUserCoursesPerPageCreator,
} from 'store/actionsCreators';
import { connect } from 'react-redux';
import { globalPropTypes, isLoading } from 'helpers';
import { useTranslation } from 'react-i18next';

const Pending = ({ loading, loadList, setPage, setPerPage, list }) => {
  const { t } = useTranslation();

  const { items, page, pages, perPage } = list;

  useEffect(() => {
    setPage(1);
    loadList();
  }, [perPage]);

  return (
    <PageContent>
      <Container>
        {loading ? <Spinner /> : null}
        {!loading ? (
          <>
            <Alerts type="user" />
            <FiltersControls
              perPageSelected={perPage}
              perPageOnChange={(payload) => setPerPage(payload.value)}
            />
            <BoxList type="course" items={items} alert={t('global.noResultsCourses')} />
            <Pagination
              styled
              currentPage={page}
              totalPages={pages}
              onChange={(payload) => {
                setPage(payload);
                loadList();
              }}
            />
          </>
        ) : null}
      </Container>
    </PageContent>
  );
};

Pending.propTypes = {
  loading: PropTypes.bool,
  loadList: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  list: globalPropTypes.ListPropsTypes.isRequired,
};

Pending.defaultProps = {
  loading: false,
};

const mapStateToProps = ({
  loading,
  user: {
    courses: { pending: list },
  },
}) => ({
  loading: isLoading(loading, 'LOAD_USER_COURSES_PENDING'),
  list,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadUserCoursesCreator('pending')),
  setPage: (payload) => dispatch(setUserCoursesPageCreator('pending', payload)),
  setPerPage: (payload) => dispatch(setUserCoursesPerPageCreator('pending', payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Pending);
